import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight, Star, Quote } from 'lucide-react';
import { testimonials } from '../mock';

export const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center space-y-4 mb-16"
        >
          <span className="inline-block px-4 py-2 bg-[#2196F3]/10 text-[#2196F3] rounded-full text-sm font-semibold">
            Testimonials
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-[#071B4D]">
            What Our Clients Say
          </h2>
          <p className="max-w-3xl mx-auto text-lg text-gray-600">
            Trusted by leading companies worldwide for exceptional technology solutions.
          </p>
        </motion.div>

        <div className="relative max-w-4xl mx-auto">
          <AnimatePresence mode="wait">
            <motion.div
              key={currentIndex}
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -50 }}
              transition={{ duration: 0.5 }}
              className="relative p-8 md:p-12 bg-white/60 backdrop-blur-lg rounded-3xl border border-gray-200 shadow-2xl"
            >
              {/* Quote Icon */}
              <div className="absolute top-8 right-8 opacity-10">
                <Quote className="w-24 h-24 text-[#2196F3]" />
              </div>

              <div className="relative">
                {/* Rating */}
                <div className="flex gap-1 mb-6">
                  {[...Array(testimonials[currentIndex].rating)].map((_, i) => (
                    <Star key={i} className="w-5 h-5 fill-[#2196F3] text-[#2196F3]" />
                  ))}
                </div>

                {/* Content */}
                <p className="text-xl md:text-2xl text-gray-700 leading-relaxed mb-8">
                  "{testimonials[currentIndex].content}"
                </p>

                {/* Author */}
                <div>
                  <div className="font-bold text-lg text-[#071B4D]">
                    {testimonials[currentIndex].name}
                  </div>
                  <div className="text-[#2196F3]">
                    {testimonials[currentIndex].position}
                  </div>
                </div>
              </div>
            </motion.div>
          </AnimatePresence>

          {/* Navigation */}
          <div className="flex items-center justify-center gap-4 mt-8">
            <button
              onClick={prevTestimonial}
              className="p-3 bg-white rounded-full shadow-lg hover:shadow-xl border border-gray-200 hover:border-[#2196F3] transition-all duration-300 group"
            >
              <ChevronLeft className="w-6 h-6 text-[#071B4D] group-hover:text-[#2196F3]" />
            </button>

            <div className="flex gap-2">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentIndex(index)}
                  className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${
                    index === currentIndex
                      ? 'bg-[#2196F3] w-8'
                      : 'bg-gray-300 hover:bg-gray-400'
                  }`}
                />
              ))}
            </div>

            <button
              onClick={nextTestimonial}
              className="p-3 bg-white rounded-full shadow-lg hover:shadow-xl border border-gray-200 hover:border-[#2196F3] transition-all duration-300 group"
            >
              <ChevronRight className="w-6 h-6 text-[#071B4D] group-hover:text-[#2196F3]" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};